//#region libraries
import React, { useEffect } from 'react';

// custom components
import { WaitingTimesTable } from '_organisms';
import { LoadingScreenContainer } from '_atoms';
// redux
import { useSelector, useDispatch } from 'react-redux';
import { selectSubmittedWaitTimes, getBeaconSubmittedTimes, selectWaitingTimesStatus } from '_redux/slices/beacons/beacons';
import { selectAirportInformation } from '_redux/slices/analytics/reviews';
import { selectUserDb } from '_redux/slices/main-screen/user';
//#endregion

const AllBeaconTimes = (props) => {

    //#region redux
    const dispatch = useDispatch();
    // beacon redux
    const submittedWaitTimes = useSelector(selectSubmittedWaitTimes);
    // user info
    const dbUser = useSelector(selectUserDb)
    const status = useSelector(selectWaitingTimesStatus)
    // airport info
    const airportInformation = useSelector(selectAirportInformation)
    const airportName = airportInformation?.[dbUser?.details?.authority]?.name ? airportInformation?.[dbUser?.details?.authority]?.name : "Your Airport"
    //#endregion

    useEffect(() => {
        dispatch(getBeaconSubmittedTimes(dbUser.details.authority))
    }, []);


    return (
        <LoadingScreenContainer loading={status == 'loading'}>
            <WaitingTimesTable showDatePicker={true} title={"Submitted Wait Times at " + airportName} subtitle={"View real-time information on how many passengers are waiting in your airport"} data={submittedWaitTimes} />
        </LoadingScreenContainer>

    );
};

export default AllBeaconTimes;
